import { Box, Container, Group, Anchor, Text, rem } from "@mantine/core";
import { Link } from "react-router-dom";
import { useTranslation } from "../context/TranslationContext";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function Footer() {
  const { t } = useTranslation();
  const { openPreferences } = useCookieConsent();
  const currentYear = new Date().getFullYear();

  const links = [
    { link: "/shipping", label: t("shipping", "Shipping") },
    { link: "/about", label: t("about", "About us") },
    { link: "/gallery", label: t("gallery", "Gallery") },
    { link: "/contact", label: t("contact", "Contact us") },
    { link: "/legal", label: t("legal", "Legal provisions") },
  ];

  return (
    <Box
      component="footer"
      mt={rem(80)}
      py="xl"
      style={{ borderTop: `${rem(1)} solid var(--mantine-color-gray-2)` }}
    >
      <Container size="lg">
        <Group justify="space-between" align="center" wrap="wrap" gap="md">
          {/* Left Side: Copyright */}
          <Text c="dimmed" size="sm">
            &copy; {currentYear} Yogi Foods. All rights reserved.
          </Text>

          {/* Right Side: links + cookie preferences control */}
          <nav aria-label={t("footerNavLabel", "Footer navigation")}>
            <Group gap="lg">
              {links.map((link) => (
                <Anchor
                  component={Link}
                  key={link.label}
                  to={link.link}
                  c="dimmed"
                  size="sm"
                  fw={500}
                  underline="hover"
                >
                  {link.label}
                </Anchor>
              ))}
              <Anchor
                component="button"
                type="button"
                onClick={openPreferences}
                c="dimmed"
                size="sm"
                fw={500}
                underline="hover"
              >
                {t("cookiesBannerManage", "Manage cookie preferences")}
              </Anchor>
            </Group>
          </nav>
        </Group>
      </Container>
    </Box>
  );
}
